import { computed } from 'vue';
import { differenceInDays, isPast, formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function usePipelineCard(card) {
  const hasDeadline = computed(() => {
    return card.value?.deadline != null;
  });

  const isOverdue = computed(() => {
    if (!hasDeadline.value) return false;
    return isPast(new Date(card.value.deadline));
  });

  const daysUntilDeadline = computed(() => {
    if (!hasDeadline.value) return null;
    return differenceInDays(new Date(card.value.deadline), new Date());
  });

  const deadlineLabel = computed(() => {
    if (!hasDeadline.value) return null;

    if (isOverdue.value) {
      return `Atrasado ${formatDistanceToNow(new Date(card.value.deadline), {
        locale: ptBR,
      })}`;
    }

    return formatDistanceToNow(new Date(card.value.deadline), {
      locale: ptBR,
      addSuffix: true,
    });
  });

  const isUrgent = computed(() => {
    return (
      isOverdue.value ||
      (daysUntilDeadline.value !== null && daysUntilDeadline.value <= 2)
    );
  });

  const hasConversation = computed(() => {
    return card.value?.conversation_display_id != null;
  });

  const hasContact = computed(() => {
    return card.value?.contact != null;
  });

  const isAssigned = computed(() => {
    return card.value?.assigned_to != null;
  });

  const displayTitle = computed(() => {
    return (
      card.value?.item_details?.title ||
      card.value?.title ||
      card.value?.contact?.name ||
      'Untitled'
    );
  });

  const displayDescription = computed(() => {
    return (
      card.value?.item_details?.description || card.value?.description || ''
    );
  });

  return {
    hasDeadline,
    isOverdue,
    daysUntilDeadline,
    deadlineLabel,
    isUrgent,
    hasConversation,
    hasContact,
    isAssigned,
    displayTitle,
    displayDescription,
  };
}
